// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface MyEventTargetOptions {}

export class MyEventTarget<EM extends { [k in string]: any }> extends EventTarget {
  static readonly EVENT_DISPATCH = '_EVENT_DISPATCH_';
  readonly options: MyEventTargetOptions;
  constructor(options?: Partial<MyEventTargetOptions>) {
    super();
    this.options = {
      ...options,
    };
  }
  addEventListener(
    type: typeof MyEventTarget.EVENT_DISPATCH,
    callback: ((event: CustomEventInit<any>) => void) | null,
    options?: AddEventListenerOptions | boolean
  ): () => void;
  addEventListener<E extends keyof EM>(
    type: E,
    callback: ((event: CustomEventInit<EM[E]>) => void) | null,
    options?: AddEventListenerOptions | boolean
  ): () => void;
  addEventListener(
    type: string,
    callback: EventListenerOrEventListenerObject | null,
    options?: AddEventListenerOptions | boolean
  ): () => void;
  addEventListener(
    type: string,
    callback: ((e: Event) => void) | null,
    options?: AddEventListenerOptions | boolean
  ) {
    super.addEventListener(type, callback, options);
    return () => {
      super.removeEventListener(type, callback, options);
    };
  }
  dispatchEvent(event: Event): boolean;
  dispatchEvent<E extends keyof EM>(type: E, detail?: EM[E]): boolean;
  dispatchEvent(event: any, detail?: any) {
    const event_ =
      event instanceof Event
        ? event
        : new CustomEvent(event, {
            detail,
          });

    super.dispatchEvent(
      new CustomEvent(MyEventTarget.EVENT_DISPATCH, {
        detail: event_,
      })
    );

    return super.dispatchEvent(event_);
  }
}
